import {
  SimpleFilterConfiguration,
  SimpleFilterDocumentDataType,
  SimpleFilterType,
} from '../interfaces'
import { Injectable } from '@angular/core'
import { WorkOrdersQuoteStatus } from '@wm-front/admin/graphql'

@Injectable({ providedIn: 'root' })
export class DocumentFiltersCatalogService {
  public getConfiguration(
    overrideConfiguration: SimpleFilterConfiguration<any>
  ): SimpleFilterConfiguration<any> {
    if (overrideConfiguration?.dataType !== undefined) {
      switch (overrideConfiguration.dataType) {
        case SimpleFilterDocumentDataType.WORK_ORDER_QUOTE_STATUS:
          return this.getWorkOrderQuoteStatus(overrideConfiguration)
      }
    }
    return overrideConfiguration
  }

  private getWorkOrderQuoteStatus(
    overrideConfiguration: SimpleFilterConfiguration<void>
  ): SimpleFilterConfiguration<void> {
    return {
      key: overrideConfiguration.key || 'quoteStatus',
      display: overrideConfiguration.display || {
        label: $localize`:Label | label@@FiltersWorkOrdersQuoteStatusButton:Status`,
      },
      type: SimpleFilterType.DROPDOWN,
      withoutSearch: true,
      data: [
        {
          label: $localize`:Label | Label for ToSign on quote filter@@filtersStateQuoteToSignTabTitle:À signer`,
          value: WorkOrdersQuoteStatus.ToSign,
        },
        {
          label: $localize`:Label | Label for Signed on quote filter@@filtersStateQuoteSignedTabTitle:Signé`,
          value: WorkOrdersQuoteStatus.Signed,
        },
        {
          label: $localize`:Label | Label for Refused on quote filter@@filtersStateQuoteRefusedTabTitle:Refusé`,
          value: WorkOrdersQuoteStatus.Refused,
        },
        {
          label: $localize`:Label | Label for Refused on quote filter@@filtersStateQuoteValidationTabTitle:En validation`,
          value: WorkOrdersQuoteStatus.Validation,
        },
      ],
    }
  }
}
